<template>
  <div>
    <h4 class="clof font32 center">可视化报告</h4>
    <line-cross></line-cross>
    <ul class="turn-box mt20" ref="turnBox">
      <li v-for="(item, index) in pageList"
          :key="index" :style="getItemStyle(item)" @click="turnItem(item,index)">
        <img :src="item.img" ref="image">
      </li>
    </ul>
  </div>
</template>

<script>
import Turn from '@/utils/turn';
import { $dg_getNavListNoTips } from '@/api';
import LineCross from './LineCross';

export default {
  name: 'HomeThird',
  data() {
    return {
      turnInstance: null,
      pageList: [
        {
          id: 6281,
          x: 0,
          zIndex: 0,
          scale: 1,
          img: require('@/assets/img/third_1.png'),
        },
        {
          id: 6282,
          x: 0,
          zIndex: 0,
          scale: 1,
          img: require('@/assets/img/third_2.png'),
        },
        {
          id: 6283,
          x: 0,
          zIndex: 0,
          scale: 1,
          img: require('@/assets/img/third_3.png'),
        },
        {
          id: 6285,
          x: 0,
          zIndex: 0,
          scale: 1,
          img: require('@/assets/img/third_4.png'),
        },
        {
          id: 6284,
          x: 0,
          zIndex: 0,
          scale: 1,
          img: require('@/assets/img/third_5.png'),
        },
      ],
      navList: [],
    };
  },
  computed: {
    smallSide() {
      const { pageList } = this;
      const middle = Math.ceil(pageList.length / 2) - 1;
      if (middle < 0) return 1;
      return middle;
    },
  },
  methods: {
    async getNavList() {
      this.navList = await $dg_getNavListNoTips();
    },
    getItemStyle({
      x, scale, zIndex, order,
    }) {
      const left = `left: calc(50% - ${x}px)`;
      let transform = `transform: translate(-50%, 0) scale(${scale}, ${scale})`;
      let deg = 30;
      if (order < 0) deg = -30;
      if (Math.abs(order) > 0) transform += ` rotateX(0deg) rotateY(${deg}deg)`;
      return `${left};${transform};z-index:${zIndex}`;
    },
    turnItem({ order, id }, index) {
      this.turnInstance.move(index);
      if (order === 0) {
        this.toDetail(id);
      }
    },
    toDetail(id) {
      const result = this.navList.find(v => v.id === id);
      if (!result) return;
      let leafId;
      if (result.children && result.children.length) {
        leafId = result.children[0].id;
      }
      this.$router.push({
        name: 'detail',
        query: {
          channelId: result.id,
          leafId,
        },
      });
    },
  },
  created() {
    this.getNavList();
  },
  mounted() {
    const options = {
      dom: this.$refs.turnBox,
      img: this.$refs.image[0],
      list: this.pageList,
      scale: 0.2,
      offset: 220,
      auto: false,
    };
    this.turnInstance = new Turn(options);
    this.pageList = this.turnInstance.init();
  },
  components: { LineCross },
};
</script>

<style scoped lang="scss">
.turn-box{
  position: relative;
  perspective: 1200px;
  height: 618px;
  li{
    cursor: pointer;
    height: 618px;
    width: 364px;
    position: absolute;
    top: 0;
    transition: all .3s;
    transform-style: preserve-3d;
    transition-duration: .3s;
    box-shadow: rgba(102, 102, 102, 0.5) 0 0 5px;
    -webkit-box-reflect: below 0 -webkit-linear-gradient(transparent 60%,rgba(0,0,0,.7));
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
